import type { HttpError } from 'utils/http'

type ValidationBody = { errors?: Record<string, string[]> }

export const searchErrorOf = (error: HttpError | null, fallback: string) => {
  const reason = error?.status === 400 ? Object.values((error.body as ValidationBody)?.errors ?? {})[0]?.[0] : null
  return reason ?? fallback
}
